import $ from 'jquery';
import modules from '../modules';

class Event {
    eventName = '';

    /**
     * Add Event
     * 
     */
    add() {
        try {
            let thisObj = this;
            document.addEventListener(this.eventName, function (e) {
                thisObj.eventFunction(e.detail);
            }, false);
        } catch (error) {
            console.log(error);
        }
    }

    /**
     * Send request
     *
     * Event Function for Send request
     *
     * @param {string} data.client_id -  id given for client
     * @param {string} data.request_id - optional - unique id for request
     * @param {string} data.action - optional - request action
     * @param {string} data.multi_call_key - optional - Enable multi call option. same key will abort previous request from that key
     * @return void
     *
     */
    sendRequest(data, cb) {
        try {
            //send request to backend and get data
            let request = new modules.Request();
            let endPoint = data.endPoint;
            let thisObj = this;
            let clientId = data.client_id;

            if (clientId) {
                request.send({
                    endPoint: data.endPoint,
                    method: (data.method) ? data.method : 'GET',
                    data: (data.data) ? data.data : {client_id: clientId},
                    authenticate: (data.authenticate != undefined) ? data.authenticate : true,
                    client_id: clientId,
                    canUsePublicAuth: (data.canUsePublicAuth != undefined) ? data.canUsePublicAuth : true,
                    multiCallKey: (data.multi_call_key) ? data.multi_call_key : '',
                    publicAuth: data.publicAuth,
                    onSuccess: function (response, status) {
                        cb(response, status);
                    },
                    onError: function (jqXHR, textStatus, errorThrown) {
                        if (textStatus?.status != 0 && textStatus?.status != 401) {
                            console.log(endPoint, textStatus);
                        }
                        
                        let responseText = (textStatus.responseText) ? JSON.parse(textStatus.responseText) : textStatus.statusText;
                        responseText = (responseText.message) ? responseText.message : responseText;

                        //fire error event
                        thisObj.onErrorEvent(
                            { message: responseText, status: textStatus.status },
                            { action: data.action, request_id: data.request_id }
                        );
                        cb(false);
                    },
                });
            }
            else {
                // fire error event
                this.onErrorEvent(
                    { message: "client_id is required", status: 422 },
                    { action: data.action, request_id: data.request_id }
                );
                cb(false);
            }
        } catch (error) {
            console.log(error);
            cb(false);
        }
    }

    /**
     * Dispatch Event
     * 
     * @param {string} eventName Event Name
     * @param {any} data data to pass for detail parameter
     */
    dispatch(eventName, data) {
        try {
            let customEvent = new CustomEvent(eventName, {
                "detail": data
            });
            document.dispatchEvent(customEvent);
        } catch (error) {
            console.log(error);
        }
    }

    /**
     * Event Function
     *  
     * @param {any} data data for the method
     */
    eventFunction(data) {
        console.log("Override this function");
    }

    /**
     * fire success event
     * 
     * @param {any} data data to pass for the event
     */
    /**
     * 
     * @param {*} data data to pass for the event
     * @param {*} options 
     */
    onSuccessEvent(data = [], options = []) {
        try {   
            if(data['logout']) {
                this.logoutEvent(data);
            }

            let response = {
                "action": (options['action']) ? options['action'] : null
            };

            $.extend(response, data);

            let requestId = (options['request_id']) ? options['request_id'] : '';
            this.dispatch(this.eventName + 'Success' + requestId, { "result": response });

        } catch (error) {
            console.log(error);
        }
    }

    /**
     * fire fail event
     * 
     * @param {*} data data to pass for the event
     * @param {*} options 
     */
    onErrorEvent(data, options = []) {
        try {
            if (data.status === 401 && (this.eventName !== 'oms_userLogin')) {
                this.logoutEvent(data);
            } else {
                let requestId = (options['request_id']) ? options['request_id'] : '';
                this.dispatch(this.eventName + 'Error' + requestId, {
                    "result": {
                        "success": false,
                        "message": data.message,
                        "status": data.status,
                        "action": (options['action']) ? options['action'] : null
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    /**
     * Logout event
     * 
     * @param {*} data 
     */
    logoutEvent(data) {
        try {
            this.dispatch('oms_userLogout', {
                client_id: data.client_id
            });
        } catch (error) {
            console.log(error);
        }
    }

    /**
     * Format data to send back to event caller
     * 
     * @param {array} data 
     * @param {string} data.authType -  optional - if api request, then authentication type values: 'public|user'
     * @param {array} data.data -  required - set of data
     * @param {string} data.data.success -  event success values : 'true|false'
     * @param {any} data.data.data -  data 
     * @param {string} data.data.total -  if api request, then total number of records
     * @param {string} data.data.message -  if api request, then api response message
     * @returns 
     */
    formatResponseData(data){
        let returnData = [];
        try {
            if ((Object.keys(data).length > 0) && (Object.keys(data.data).length > 0)) {
                returnData = {
                    auth_type: (data.authType) ? data.authType : null,
                    logout: (data.logout) ? data.logout : null,
                    client_id: (data.client_id) ? data.client_id : null,
                    success: (data.data.success) ? data.data.success : false,
                    message: (data.data.message) ? data.data.message : null,
                    data: (data.data.data) ? data.data.data : null,
                    total: (data.data.total) ? data.data.total : null,
                    start: (data.data.start) ? data.data.start : null,
                };
            }
        } catch (error) {
            console.log(error);
        }

        return returnData;
    }

    load() {
        return true;
    }

}

export default Event;